import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthModule } from './auth.module';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: AuthModule,
})
export class RoleGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const { roles } = route?.data;
        if (roles && roles.read) {
            return this.authService.hasRole(roles.read).pipe(
                tap((canPass) => {
                    if (!canPass) {
                        this.router.navigate(['auth']);
                    }
                })
            );
        }
        return of(true);
    }
}
